import { Fancybox } from '@fancyapps/ui'

document.addEventListener('DOMContentLoaded', function (e) {
  const singleProject = e.target.querySelector('.single-project')
  if (singleProject) {
    Fancybox.bind('[data-fancybox]', {})
  }
})
